import { reactive } from 'vue'
import { api } from '../api/client'
import { normalizeUser } from '../api/mappers'

export const session = reactive({
  user: null,
  ready: false,
  pending: false,

  async restore() {
    if (this.ready) return this.user
    try {
      const payload = await api.auth.me()
      this.user = normalizeUser(payload?.user || payload)
    } catch (error) {
      if (error.status !== 401) console.warn('Не удалось проверить сессию', error)
      this.user = null
    } finally {
      this.ready = true
    }
    return this.user
  },

  async login(credentials) {
    this.pending = true
    try {
      const payload = await api.auth.login(credentials)
      this.user = normalizeUser(payload?.user || payload)
      this.ready = true
      return this.user
    } finally {
      this.pending = false
    }
  },

  async logout() {
    try {
      await api.auth.logout()
    } finally {
      this.user = null
      this.ready = true
    }
  },
})

export function useSession() {
  return session
}
